<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <!-- ===== HERO ===== -->
  <section class="relative min-h-[85vh] flex items-center pt-24 pb-16 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 -left-24 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]"
      style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;">
    </div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <a routerLink="/" class="back-nav" data-aos="fade-down">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Back
          </a>
          <h1 class="hero-col font-black mb-6" data-aos="fade-up" data-aos-delay="100">
            Explore <span class="text-varroc-accent">Hardware</span>
          </h1>
          <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-xl" data-aos="fade-up"
            data-aos-delay="200">
            A complete range of smart automotive hardware OBD, TCU, Dashcam, and Digital Cluster—designed to deliver
            real-time insights, safety, and a fully connected driving experience. </p>
          <div class="flex flex-wrap gap-4 mb-10" data-aos="fade-up" data-aos-delay="300">
            <a routerLink="/store/product"
              class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all flex items-center gap-2 explore_hardware_shop_now_button">
              <i class='bx bx-shopping-bag text-xl'></i> Shop Now
            </a>
            <a routerLink="/contact-us"
              class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all explore_hardware_request_bulk_quote_button">
              Request Bulk Quote
            </a>
          </div>
          <!-- Quick stats -->
          <div class="flex flex-wrap gap-6" data-aos="fade-up" data-aos-delay="400">
            <div class="text-left">
              <div class="text-varroc-accent font-black text-2xl">-40°C to +85°C</div>
              <div class="text-varroc-text-gray text-xs mt-1">Operating Temperature</div>
            </div>
            <div class="text-left">
              <div class="text-varroc-accent font-black text-2xl">IP67</div>
              <div class="text-varroc-text-gray text-xs mt-1">Dust & Water Rating</div>
            </div>
            <div class="text-left">
              <div class="text-varroc-accent font-black text-2xl">AIS-140</div>
              <div class="text-varroc-text-gray text-xs mt-1">Government Certified</div>
            </div>
          </div>
        </div>

        <!-- Microsite entry cards -->
        <div class="grid md:grid-cols-2 gap-4" data-aos="fade-left" data-aos-delay="200">
          <a *ngFor="let card of heroCards" [routerLink]="card.route"
            class="feature-card group text-left min-h-[220px] flex flex-col justify-between hover:border-varroc-accent/40 hover:-translate-y-1 transition-all duration-300">
            <div>
              <div class="w-12 h-12 rounded-xl bg-varroc-accent/15 flex items-center justify-center mb-5">
                <i class='bx icon-gradient text-2xl' [class]="card.icon"></i>
              </div>
              <div class="text-varroc-accent text-xs font-bold uppercase tracking-[0.2em] mb-2">{{ card.eyebrow }}</div>
              <div class="text-white font-bold text-xl mb-3">{{ card.title }}</div>
              <p class="text-varroc-text-gray text-sm leading-relaxed">{{ card.desc }}</p>
            </div>
            <div
              class="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white group-hover:text-varroc-accent transition-colors">
              <span>{{ card.cta }}</span>
              <i class='bx bx-right-arrow-alt text-xl'></i>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== STICKY NAV ===== -->
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id"
          class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-32">

    <!-- ===== OBD DONGLE ===== -->
    <section id="obd" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div data-aos="fade-right">
          <div
            class="inline-flex items-center gap-2 px-3 py-1 bg-varroc-accent/10 border border-varroc-accent/20 rounded-full text-varroc-accent text-xs font-bold mb-4">
            ⭐ Best Seller</div>
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest block mb-2">OBD Dongle</span>
          <h2 class="text-4xl font-black mb-4">Varroc OBD-II Smart Dongle</h2>
          <p class="text-varroc-text-gray leading-relaxed mb-6">Plug into any OBD-II port and gain instant access to
            100+ vehicle parameters. Self-install in under 60 seconds. Compatible with all petrol and diesel vehicles
            from 2008 onwards.</p>
          <div class="grid grid-cols-2 gap-4 mb-8">
            <div *ngFor="let spec of obdSpecs" class="bg-varroc-dark border border-varroc-border rounded-lg p-3">
              <div class="text-varroc-text-gray text-xs mb-1">{{ spec.label }}</div>
              <div class="text-white font-bold text-sm">{{ spec.val }}</div>
            </div>
          </div>
          <div class="flex gap-4">
            <a routerLink="/store/product"
              class="bg-varroc-accent text-white font-bold px-6 py-3 rounded-md hover:bg-varroc-accent-hover transition-all varroc_obd_smart_dongle_buy_₹2,999_button">
              Buy — ₹2,999
            </a>
            <a routerLink="/contact-us"
              class="border border-varroc-accent/40 font-semibold px-6 py-3 rounded-md hover:border-varroc-accent transition-all varroc_obd_get_datasheet_button">
              Get Datasheet
            </a>
          </div>
        </div>
        <div class="space-y-4" data-aos="fade-left">
          <h3 class="text-white font-bold text-xl mb-4">Key Capabilities</h3>
          <div *ngFor="let f of obdFeatures"
            class="flex items-start gap-4 p-4 rounded-xl border border-varroc-border hover:border-varroc-accent/30 transition-all">
            <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
              <i class='bx icon-gradient text-xl' [class]="f.icon"></i>
            </div>
            <div>
              <div class="text-white font-semibold text-sm mb-0.5">{{ f.title }}</div>
              <div class="text-varroc-text-gray text-xs">{{ f.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== TCU ===== -->
    <section id="tcu" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-center">
        <div data-aos="fade-right">
          <div
            class="inline-flex items-center gap-2 px-3 py-1 bg-varroc-accent/10 border border-varroc-accent/20 rounded-full text-varroc-accent text-xs font-bold mb-4">
            Enterprise Ready</div>
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest block mb-2">TCU Hardware</span>
          <h2 class="text-4xl font-black mb-4">Varroc Telematics Control Unit</h2>
          <p class="text-varroc-text-gray leading-relaxed mb-6">A hardwired telematics unit built for OEM, fleet, and
            enterprise deployments where always-on connectivity, secure data capture, and OTA readiness are mandatory.
          </p>
          <div class="grid grid-cols-2 gap-4 mb-8">
            <div *ngFor="let spec of tcuSpecs" class="bg-varroc-dark border border-varroc-border rounded-lg p-3">
              <div class="text-varroc-text-gray text-xs mb-1">{{ spec.label }}</div>
              <div class="text-white font-bold text-sm">{{ spec.val }}</div>
            </div>
          </div>
          <div class="flex gap-4">
            <a routerLink="/products/hardware/tcu"
              class="bg-varroc-accent text-white font-bold px-6 py-3 rounded-md hover:bg-varroc-accent-hover transition-all varroc_telematics_control_unit_explore_tcu_button">
              Explore TCU
            </a>
            <a routerLink="/contact-us"
              class="border border-varroc-accent/40 font-semibold px-6 py-3 rounded-md hover:border-varroc-accent transition-all varroc_telematics_control_unit_request_integration_button">
              Request Integration
            </a>
          </div>
        </div>
        <div class="space-y-4" data-aos="fade-left">
          <h3 class="text-white font-bold text-xl mb-4">Key Capabilities</h3>
          <div *ngFor="let feature of tcuFeatures"
            class="flex items-start gap-4 p-4 rounded-xl border border-varroc-border hover:border-varroc-accent/30 transition-all">
            <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
              <i class='bx icon-gradient text-xl' [class]="feature.icon"></i>
            </div>
            <div>
              <div class="text-white font-semibold text-sm mb-0.5">{{ feature.title }}</div>
              <div class="text-varroc-text-gray text-xs">{{ feature.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>



    <!-- ===== DASHCAM ===== -->
    <section id="camera" class="section-anchor">
      <div class="mb-14" data-aos="fade-up">
        <div
          class="inline-flex items-center gap-2 px-3 py-1 bg-varroc-accent/10 border border-varroc-accent/20 rounded-full text-varroc-accent text-xs font-bold mb-4">
          New Arrival</div>
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest block mb-3">DashCam</span>
         <h1 class="hero-col font-black" data-aos="fade-up" data-aos-delay="100">
            Hiker by Varroc presents <span class="text-varroc-accent">Camzo</span>
          </h1>
          <h4 class="text-varroc-text-gray mb-3">A smart eye for every smart driving.</h4>
        <p class="text-varroc-text-gray text-lg max-w-2xl mr-auto">Dual-camera smart dashcam with 2K front + 1K rear
          recording, Wi-Fi app access, playback, trip reports, and contextual alerts through the Varroc Connect App.</p>
      </div>

      <div class="grid md:grid-cols-3 gap-6">
        <div class="md:col-span-2 grid grid-cols-2 gap-4" data-aos="fade-left">
          <div *ngFor="let f of camFeatures; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
            [attr.data-aos-delay]="(i * 60).toString()">
            <i class='bx icon-gradient text-xl mb-2' [class]="f.icon"></i>
            <h4 class="text-white font-bold text-sm mb-1">{{ f.title }}</h4>
            <p class="text-varroc-text-gray text-xs leading-relaxed">{{ f.desc }}</p>
          </div>
        </div>
        <div class="md:col-span-1 space-y-4" data-aos="fade-right">
          <div *ngFor="let spec of camSpecs"
            class="bg-varroc-dark border border-varroc-border rounded-xl p-4 flex justify-between items-center">
            <span class="text-varroc-text-gray text-sm">{{ spec.label }}</span>
            <span class="text-white font-semibold text-sm">{{ spec.val }}</span>
          </div>
        </div>
      </div>
      <div class="mt-10" data-aos="fade-up">
        <a routerLink="/products/hardware/dashcam"
          class="inline-block bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all text-lg hiker_by_varroc_view_smart_dashcam_button">
          View Smart Dashcam
        </a>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- ===== DIGITAL CLUSTER ===== -->
    <!-- <section id="cluster" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-start">
        <div data-aos="fade-right">
          <div
            class="inline-flex items-center gap-2 px-3 py-1 bg-varroc-accent/10 border border-varroc-accent/20 rounded-full text-varroc-accent text-xs font-bold mb-4">
            Connected Cockpit</div>
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest block mb-2">Digital Cluster</span>
          <h2 class="text-4xl font-black mb-4">Varroc Digital Cluster</h2>
          <p class="text-varroc-text-gray leading-relaxed mb-6">A retrofit-ready digital instrument cluster that brings
            real-time vehicle telemetry, smart alerts, and connected cockpit experiences to modern and legacy vehicles.
          </p>
          <div class="grid grid-cols-2 gap-4 mb-8">
            <div *ngFor="let spec of clusterSpecs" class="bg-varroc-dark border border-varroc-border rounded-lg p-3">
              <div class="text-varroc-text-gray text-xs mb-1">{{ spec.label }}</div>
              <div class="text-white font-bold text-sm">{{ spec.val }}</div>
            </div>
          </div>
          <div class="flex gap-4">
            <a routerLink="/products/hardware/cluster"
              class="bg-varroc-accent text-white font-bold px-6 py-3 rounded-md hover:bg-varroc-accent-hover transition-all">
              Explore Cluster
            </a>
            <a routerLink="/contact-us"
              class="border border-varroc-accent/40 font-semibold px-6 py-3 rounded-md hover:border-varroc-accent transition-all">
              Talk to Our Team
            </a>
          </div>
        </div>
        <div class="space-y-4 md:pt-44" data-aos="fade-left">
          <h3 class="text-white font-bold text-xl mb-4">Key Capabilities</h3>
          <div *ngFor="let feature of clusterFeatures"
            class="flex items-start gap-4 p-4 rounded-xl border border-varroc-border hover:border-varroc-accent/30 transition-all">
            <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
              <i class='bx icon-gradient text-xl' [class]="feature.icon"></i>
            </div>
            <div>
              <div class="text-white font-semibold text-sm mb-0.5">{{ feature.title }}</div>
              <div class="text-varroc-text-gray text-xs">{{ feature.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </section> -->


    <!-- CTA -->
    <!-- <section class="text-center py-16 bg-gradient-to-r from-varroc-accent/10 via-varroc-dark to-varroc-accent/10 border border-varroc-accent/20 rounded-3xl" data-aos="fade-up">
      <h2 class="text-4xl font-black mb-4">Need Custom Hardware Integration?</h2>
      <p class="text-varroc-text-gray text-lg mb-8 max-w-xl mx-auto">Our hardware team provides full ODM/OEM support — from custom firmware to branded packaging and bulk supply agreements.</p>
      <div class="flex flex-wrap gap-4 justify-center">
        <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-10 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all text-lg">
          Contact Hardware Team
        </a>
        <a routerLink="/store/product" class="border border-varroc-accent/40 font-semibold px-10 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all text-lg">
          Shop Consumer Devices
        </a>
      </div>
    </section> -->

  </div>
</main>